import _isNil from 'lodash/isNil';
import {I18n} from 'react-redux-i18n';

export const formatPolicy = (policyName, policyType) => {
  const policyTypeOrEmpty = (!_isNil(policyType))
    ? I18n.t(`policyTypes.${policyType}`)
    : '';
  return (!_isNil(policyName)) ? `${policyTypeOrEmpty} : ${policyName}` : '';
};
